require('es6-promise').polyfill();
import axios from 'axios'
import forEach from 'lodash/forEach'
import { ErrorBag } from '@/system/helpers/Validate'
import store from './store'

let instance = axios.create({
    headers: {
        'X-CSRF-TOKEN': document.querySelector("meta[name='csrf-token']").getAttribute('content'),
        'X-Requested-With' : 'XMLHttpRequest',
    }
})

export function submitForm (url, formElem, opts) {
    return instance.post(url, new FormData(formElem), opts)
}

// Intercept response
instance.interceptors.response
    .use((response) => {
        const skipGlobalIntercept = Boolean(response.config?.epSkipGlobalIntercept) || false;

        if (skipGlobalIntercept) {
            return response;
        }

        // Handle redirects for aspit user for migration_status in [awaiting_data_migration, migrating_data, failed]
        if (response.data.redirect) {
            window.location.href = response.data.redirect
            return;
        }
        // In case 200-299 returns "error"
        if (response.data.error || response.data.errors) {

            if(response.data.error && typeof swal !== 'undefined'){
                swal({
                    title: '',
                    text: response.data.error,
                    type: "warning",
                    html: true
                });
            }

            return Promise.reject({
                error: response.data.error ? response.data.error : response.data.errors,
                response,
            })
        }

        if (response.config.url.indexOf('ping') === -1 || (response.config.url.indexOf('ping') !== -1 && response.config.params && response.config.params.force)) {
            store.dispatch('auth/recordLastActivity')
        }

        return response
    }, async (error) => {
        const skipGlobalIntercept = Boolean(error.config?.epSkipGlobalIntercept) || false;

        let errorBag = new ErrorBag()
        if (!skipGlobalIntercept && error.response) {

            if (error.response.data?.frontendEvent) {
                window.$event_bus.$emit(error.response.data.frontendEvent);
                return Promise.reject({ error, errorBag, response: error.response });
            }

            // Laravel validation error
            if (error.response.status === 422) {
                if (error.response.request.responseType === 'blob'
                 && error.response.data instanceof Blob
                 && error.response.data.type === 'application/json') {
                    error.response.data = JSON.parse(await error.response.data.text());
                }
                forEach(error.response.data, (value, key) => {
                    value.forEach(message => errorBag.add({ field: key, msg: message }))
                })
            } else if (error.response.status === 402) {
                // if there is a payment required Status from the server, we will always show the Upgrade Modal
                window.$event_bus.$emit('showUpgradeModal', error.response.data);
            } else if (error.response.status === 401 && error.response.config.url.indexOf('ping') === -1) {
                window.$event_bus.$emit('unauthenticated')
            } else if (error.response.status === 419) {
                window.$event_bus.$emit('csrf_mismatch');
            } else if (error.response.status === 404) {
                // Don't show information about 404 errors
            } else if (error.response.status === 403 && error.response.data['error'] === 'Secure authentication required') {
                // Don't show errors that stem from the user trying to interact with an app that requires secure authentication
                // (2FA or MitID/BankID/HelseID)
            } else if (error.response.status === 429 && typeof swal !== 'undefined') {
                swal(
                    trans('global.too_many_requests'),
                    trans('global.too_many_requests_desc'),
                    'warning'
                );
            } else if (error.response.data && typeof swal !== 'undefined') {
                const response = error.response.data;

                var error_text = trans('global.error');

                if(response.error){
                    error_text = response.error;
                }
                if(response.data){
                    error_text = response.data;
                }

                swal({
                    title: trans('global.error_title'),
                    text: error_text,
                    type: 'warning',
                    html: true,
                });
            }
        }

        return Promise.reject({
            error,
            errorBag,
            response: error.response
        })
    })


export let http = instance
